import { render, staticRenderFns } from "./S3Reader.vue?vue&type=template&id=6792bb34"
import script from "./S3Reader.vue?vue&type=script&lang=ts"
export * from "./S3Reader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6792bb34')) {
      api.createRecord('6792bb34', component.options)
    } else {
      api.reload('6792bb34', component.options)
    }
    module.hot.accept("./S3Reader.vue?vue&type=template&id=6792bb34", function () {
      api.rerender('6792bb34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/aws/S3Reader.vue"
export default component.exports